'use client';

import { FC } from 'react';

import { ProductMetadata } from '@telialt/models/src/EshopModel';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

import { useBaseProductFromUrlParam } from '../../../hooks/useBaseProductFromUrlParam';
import { useProductMetadata } from '../../../hooks/useProductMetadata';

const selectProductSchemaString = (metadata: ProductMetadata) => {
    try {
        return metadata?.jsonScripts?.find((script) => JSON.parse(script)?.['@type'] === 'Product');
    } catch (error) {
        const datadogLogs = datadogLogger();
        datadogLogs.error('Error parsing product metadata', { error, component: DDComponent.Eshop });

        return null;
    }
};

export const ProductSchema: FC = () => {
    const { baseProduct } = useBaseProductFromUrlParam();

    const { data: metadata } = useProductMetadata(baseProduct?.url);

    const productSchemaString = selectProductSchemaString(metadata);

    if (!productSchemaString) {
        return null;
    }

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: productSchemaString,
            }}
        />
    );
};
